import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { LockIcon } from '../../components/icons';
import withFontClassName from '../../hoc/with-font-class-name';
import withCardBorderWidth from '../../hoc/with-card-border-width';
import styles from './commenting-disabled.scss';

const CommentingDisabled = ({ message, contentFontClassName, borderWidth }) => {
  const containerClassName = classNames(
    styles.container,
    contentFontClassName,
    'forum-card-background-color',
    'forum-card-border-color',
    'forum-text-color'
  );

  return (
    <div className={containerClassName} style={{ borderWidth }} data-hook="disabled-commenting">
      <span className={styles.wrapper}>
        <LockIcon className={styles.icon}/>
        {message}
      </span>
    </div>
  );
};

CommentingDisabled.propTypes = {
  message: PropTypes.string.isRequired,
  contentFontClassName: PropTypes.string.isRequired,
  borderWidth: PropTypes.number.isRequired,
};

export default withFontClassName(withCardBorderWidth(CommentingDisabled));



// WEBPACK FOOTER //
// ./app/components/commenting-disabled/commenting-disabled.js